module.exports = __webpack_public_path__ + "img/001.6ebbb9b6.png";